import { NgModule } from "@angular/core";
import { CommonModule } from "@angular/common";
import { TablePaginatorComponent } from "./components/table-paginator/table-paginator.component";
import { TranslateModule } from "@ngx-translate/core";
import { NgxMaskModule, IConfig } from "ngx-mask";
export const options: Partial<IConfig> | (() => Partial<IConfig>) = null;
import { NgxPermissionsModule } from "ngx-permissions";
import { PermissionsComponent } from "./components/permissions/permissions.component";
import { MaterialModule } from "../app.module";
import { FormsModule, ReactiveFormsModule } from "@angular/forms";

//Shared Components
import { AddSupplierComponent } from "../shelter-management/suppliers/add-supplier/add-supplier.component";
import { SuppliersComponent } from "../shelter-management/suppliers/suppliers.component";
import { ConfigSupplierComponent } from "../shelter-management/suppliers/config-supplier/config-supplier.component";
import { CurrencySupplierComponent } from "../shelter-management/suppliers/config-supplier/currency-supplier/currency-supplier.component";
import { TaxdataSupplierComponent } from "../shelter-management/suppliers/config-supplier/taxdata-supplier/taxdata-supplier.component";
import { ProductOrderComponent } from "../purchasing/product/product-order/product-order.component";
import { ContactSupplierComponent } from "../shelter-management/suppliers/config-supplier/contact-supplier/contact-supplier.component";
import { ChipListComponent } from "./components/chip-list/chip-list.component";
//import { PurchaseOrderComponent } from '../purchasing/purchase-order/purchase-order.component';
import { AddPurchaseOrderComponent } from "../purchasing/purchase-order/add-purchase-order/add-purchase-order.component";
import { NotificationRequestComponent } from "./components/notification-request/notification-request.component";
import { MenuListComponent } from "./components/menu-list/menu-list.component";
import { AddPaymentRequestComponent } from "../purchasing/payment-request/add-payment-request/add-payment-request.component";
import { AddAgainstReceiptComponent } from "../suppliers/against-receipt/add-against-receipt/add-against-receipt.component";
import { AgainstReceiptComponent } from "../suppliers/against-receipt/against-receipt.component";
import { AddInvoiceComponent } from "../suppliers/invoice/add-invoice/add-invoice.component";
import { TaxesSelectComponent } from "./components/taxes-select/taxes-select.component";
import { GenericSelectComponent } from "./components/generic-select/generic-select.component";
import { MatSelectFilterModule } from "mat-select-filter";
import { LoaderComponent } from "./components/loader/loader.component";
import { PdfPreviewDialogComponent } from "./components/pdf-preview-dialog/pdf-preview-dialog.component";
import { SatOpinionVerificationDialogComponent } from "./components/sat-opinion-verification-dialog/sat-opinion-verification-dialog.component";

//TODO: ADD OR DECLARE LOADER COMPONENT

@NgModule({
  declarations: [
    //PurchaseOrderComponent,
    AddPurchaseOrderComponent,
    ContactSupplierComponent,
    ProductOrderComponent,
    TablePaginatorComponent,
    PermissionsComponent,
    AddSupplierComponent,
    SuppliersComponent,
    ConfigSupplierComponent,
    CurrencySupplierComponent,
    TaxdataSupplierComponent,
    ChipListComponent,
    NotificationRequestComponent,
    MenuListComponent,
    AddPaymentRequestComponent,
    AgainstReceiptComponent,
    AddAgainstReceiptComponent,
    AddInvoiceComponent,
    TaxesSelectComponent,
    GenericSelectComponent,
    LoaderComponent,
    PdfPreviewDialogComponent,
    SatOpinionVerificationDialogComponent,
  ],
  exports: [
    AgainstReceiptComponent,
    AddAgainstReceiptComponent,
    AddPaymentRequestComponent,
    //PurchaseOrderComponent,
    AddPurchaseOrderComponent,
    ContactSupplierComponent,
    ProductOrderComponent,
    ConfigSupplierComponent,
    AddSupplierComponent,
    SuppliersComponent,
    TablePaginatorComponent,
    PermissionsComponent,
    ChipListComponent,
    MenuListComponent,
    TranslateModule,
    NgxMaskModule,
    NgxPermissionsModule,
    MaterialModule,
    AddInvoiceComponent,
    TaxesSelectComponent,
    GenericSelectComponent,
    LoaderComponent,
    PdfPreviewDialogComponent,
    SatOpinionVerificationDialogComponent,
  ],
  imports: [
    FormsModule,
    ReactiveFormsModule,
    MaterialModule,
    CommonModule,
    TranslateModule.forChild(),
    NgxMaskModule.forChild(),
    NgxPermissionsModule.forChild(),
    MatSelectFilterModule,
  ],
})
export class GenericSharedModule {}
